import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { MdOutlineWatchLater } from "react-icons/md";
import { BsCurrencyRupee } from "react-icons/bs";
import { MdArrowDropDown } from "react-icons/md";
import { MdWatchLater } from "react-icons/md";
import UserSidebar from "./UserSidebar";
import Constant from "../Components/Utils/Constant";

export default function AffiliatedDashboard() {
  // for const values
  const salesValue = useState("15,000");
  const revenueValue = useState("5,100");
  const [activeUsersValue, setActiveUsersValue] = useState(0);
  const [inactiveUsersValue, setInactiveUsersValue] = useState(0);
  const [expiredUsersValue, setExpiredUsersValue] = useState(0);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [user, setUser] = useState([]);
  const [totalCount, setTotalCount] = useState(null);
  const [totalPages, setTotalPages] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const tableRef = React.createRef();
  const [userName, setUserName] = useState("");
  const [createdAt, setCreatedAt] = useState(null);
  const [hittime, setHittime] = useState(null);
  // for dropdown

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  // for time date
  const [currentTime, setCurrentTime] = useState(new Date());
  const navigate = useNavigate();
  const currentDate = new Date();
  useEffect(() => {
    const intervalId = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);
    return () => clearInterval(intervalId);
  }, []);
  const formattedTime = currentTime.toLocaleTimeString();
  const formattedDate = currentDate.toLocaleTimeString();

  // get api
  useEffect(() => {
    const storedName = localStorage.getItem("name");
    setUserName(storedName)

    const fetchUser = async () => {
      try {
        const response = await fetch(`${Constant.BASE_URL}/user/getByAffiliate`,
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              createdBy: storedName,
            }),
          });
        const data = await response.json();
        if (data && data.admins) {
          setUser(data.admins);
          if (data.success) {
            setTotalCount(data.totalCount);
            setTotalPages(data.totalPages);
            setExpiredUsersValue(data.expirycount);
            setActiveUsersValue(data.activecount)
            setCreatedAt(data.createdAt)
            setHittime(data.hittime)
          }
        }
      } catch (error) {
        console.error('Error fetching users:', error);
      }
    };
    fetchUser();
  }, []);
  console.log(expiredUsersValue, "setExpiredUsersValue")


  return (
    <UserSidebar>
      <>
        <div className="flex items-center h-scrren ">
          <div className="flex bg-gray-300 overflow-y-auto h-[80vh] main3table" style={{ scrollPaddingBottom: "250px" }}>
            <div className="flex cardscar w-100 ">
              {/* cards main div */}
              <div className="w-[55%] flex justify-center items-center  flex-wrap py-5 lg:py-3 xl:py-5 2xl:py-7 lg:gap-5 xl:gap-5 2xl:gap-8">
                {/* cards div */}
                <div
                  className="w-[45%] lg:w-[45%] xl:w-[45%] 2xl:w-[46%]   rounded-md overflow-hidden transition-all duration-200"
                  style={{
                    boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.25)",
                    // border: "1px solid #F0F0F0",
                  }}
                >
                  <div
                    style={{
                      background:
                        "radial-gradient(153.7% 1063.14% at 108.27% 49.55%, rgba(148, 239, 140, 0.85) 0%, rgba(20, 139, 0, 0.85) 100%)",
                    }}
                    className="flex flex-col text-white"
                  >
                    <div className="flex justify-end px-5 pt-4 2xl:py-7">
                      <h3 className="flex items-center text-[35px] lg:text-[22px] xl:text-[36px] 2xl:text-[60px]">
                        <span>
                          <BsCurrencyRupee />
                        </span>{" "}
                        {salesValue}
                      </h3>
                    </div>
                    <div className=" text-[22px] lg:pt-[20px] xl:pt-[4px] lg:text-[18px] xl:text-[26px] 2xl:text-[48px] 2xl:pb-4 px-5 pb-2 pt-0 2xl:pt-[40px]">
                      <p>Sales</p>
                    </div>
                    <hr className="p-1"></hr>
                    <div className="flex lg:pb-4 xl:pb-6 lg:px-2 xl:px-5 text-[12px] lg:text-[9px] xl:text-[12px]  2xl:text-[20px] 2xl:py-3 2xl:pb-12">
                      <ul className="flex items-center space-4xl lg:space-xl xl:space-4xl">
                        <li>
                          <MdOutlineWatchLater className="text-lg lg:text-xs xl:text-lg 2xl:text-4xl" />
                        </li>
                        <li>
                          <p className="pl-2 pr-5 lg:pr-1 xl:pr-5 2xl:text-2xl">
                            Update :
                          </p>
                        </li>
                        <li className="2xl:text-2xl">
                          <p>
                            {" "}
                            {formattedDate}, {formattedTime}
                          </p>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>

                <div
                  className="w-[45%] lg:w-[45%] xl:w-[45%] 2xl:w-[46%]  rounded-md overflow-hidden transition-all duration-200"
                  style={{
                    boxShadow: " 0px 4px 4px 0px rgba(0, 0, 0, 0.25)",
                    // border: "1px solid rgba(254, 208, 88, 0.85)",
                  }}
                >
                  <div
                    style={{
                      background:
                        "radial-gradient(153.7% 1063.14% at 108.27% 49.55%, rgba(254, 208, 88, 0.85) 0%, rgba(255, 138, 0, 0.85) 100%)",
                    }}
                    className="flex flex-col text-white"
                  >
                    <div className="flex justify-end px-5 pt-4 2xl:py-7">
                      <h3 className="flex items-center text-[35px] lg:text-[22px] xl:text-[36px] 2xl:text-[60px]">
                        <span>
                          <BsCurrencyRupee />
                        </span>{" "}
                        {revenueValue}
                      </h3>
                    </div>
                    <div className=" text-[22px] lg:pt-[20px] xl:pt-[4px] lg:text-[18px] xl:text-[26px] 2xl:text-[48px] 2xl:pb-4 px-5 pb-2 pt-0 2xl:pt-[40px]">
                      <p> Revenue</p>
                    </div>
                    <hr className="p-1"></hr>
                    <div className="flex lg:pb-4 xl:pb-6 lg:px-2 xl:px-5 text-[12px] lg:text-[9px] xl:text-[12px] 2xl:text-[20px] 2xl:py-3 2xl:pb-12">
                      <ul className="flex items-center space-4xl lg:space-0xl xl:space-4xl">
                        <li>
                          <MdOutlineWatchLater className=" lg:text-xs xl:text-lg 2xl:text-4xl" />
                        </li>
                        <li>
                          <p className="pl-2 pr-5 lg:pr-1 xl:pr-5 2xl:text-2xl">
                            Update :
                          </p>
                        </li>
                        <li className="2xl:text-2xl">
                          <p>
                            {" "}
                            {formattedDate}, {formattedTime}
                          </p>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>

                <div
                  className="w-[45%] lg:w-[45%] xl:w-[45%] 2xl:w-[46%] rounded-md overflow-hidden transition-all duration-200"
                  style={{
                    boxShadow: " 0px 4px 4px 0px rgba(0, 0, 0, 0.25)",
                    // border: "1px solid rgba(140, 144, 239, 0.85)",
                  }}
                >
                  <div
                    style={{
                      background:
                        "radial-gradient(153.7% 1063.14% at 108.27% 49.55%, rgba(140, 144, 239, 0.85) 0%, rgba(78, 0, 139, 0.85) 100%)",
                    }}
                    className="flex flex-col text-white"
                  >
                    <div className="flex justify-end px-5 pt-4 2xl:py-5">
                      <h3 className="flex items-center text-[35px] lg:text-[22px] xl:text-[36px] 2xl:text-[60px]">
                        {activeUsersValue}
                      </h3>
                    </div>
                    <div className=" text-[22px] lg:pt-[20px] xl:pt-[4px] lg:text-[18px] xl:text-[26px]  2xl:text-[48px] 2xl:pb-4 px-5 pb-2 pt-0  2xl:pt-[40px]">
                      <p>Active Users</p>
                    </div>
                    <hr className="p-1"></hr>
                    <div className="flex lg:pb-4 xl:pb-6 lg:px-2 xl:px-5 text-[12px] lg:text-[9px] xl:text-[12px]  2xl:text-[20px] 2xl:py-3 2xl:pb-12">
                      <ul className="flex items-center space-4xl lg:space-2xl xl:space-4xl">
                        <li>
                          <MdOutlineWatchLater className="text-lg lg:text-xs xl:text-lg 2xl:text-4xl" />
                        </li>
                        <li>
                          <p className="pl-2 pr-5 lg:pr-1 xl:pr-5 2xl:text-2xl">
                            Update :
                          </p>
                        </li>
                        <li className="2xl:text-2xl">
                          <p>
                            {hittime?.split('T')[0]} Time {hittime?.split('T')[1]?.split('.')[0]}
                          </p>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>

                <div
                  className="w-[45%] lg:w-[45%] xl:w-[45%] 2xl:w-[46%] rounded-md overflow-hidden transition-all duration-200"
                  style={{
                    boxShadow: " 0px 4px 4px 0px rgba(0, 0, 0, 0.25)",
                    // border: "1px solid rgba(254, 88, 128, 0.85)",
                  }}
                >
                  <div
                    style={{
                      background:
                        "radial-gradient(153.7% 1063.14% at 108.27% 49.55%, rgba(254, 88, 128, 0.85) 0%, rgba(255, 0, 61, 0.85) 100%)",
                    }}
                    className="flex flex-col text-white"
                  >
                    <div className="flex justify-end px-5 pt-4 2xl:py-5">
                      <h3 className="flex items-center text-[35px] lg:text-[22px] xl:text-[36px] 2xl:text-[60px]">
                        {inactiveUsersValue}
                      </h3>
                    </div>
                    <div className=" text-[22px] lg:pt-[20px] xl:pt-[4px] lg:text-[18px] xl:text-[26px]  2xl:text-[48px] 2xl:pb-4 px-5 lg:pr-0 pb-2 pt-0  2xl:pt-[40px]">
                      <p>Inactive Users</p>
                    </div>
                    <hr className="p-1"></hr>
                    <div className="flex lg:pb-4 xl:pb-6 lg:px-2 xl:px-5 text-[12px] lg:text-[9px] xl:text-[12px]  2xl:text-[20px] 2xl:py-3 2xl:pb-12">
                      <ul className="flex items-center space-4xl lg:space-2xl xl:space-4xl">
                        <li>
                          <MdOutlineWatchLater className="text-lg lg:text-xs xl:text-lg 2xl:text-4xl" />
                        </li>
                        <li>
                          <p className="pl-2 pr-5 lg:pr-1 xl:pr-5 2xl:text-2xl">
                            Update :
                          </p>
                        </li>
                        <li className="2xl:text-2xl">
                          <p>
                            {hittime?.split('T')[0]} Time {hittime?.split('T')[1]?.split('.')[0]}
                          </p>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>

                <div
                  className="w-[45%] lg:w-[45%] xl:w-[45%] 2xl:w-[46%] rounded-md overflow-hidden transition-all duration-200"
                  style={{
                    boxShadow: " 0px 4px 4px 0px rgba(0, 0, 0, 0.25)",
                    // border: "1px solid rgba(254, 88, 128, 0.85)",
                  }}
                >
                  <div
                    style={{
                      background:
                        "radial-gradient(153.7% 1063.14% at 108.27% 49.55%, rgba(180, 218, 26, 0.85) 0%, rgba(249, 90, 40, 0.85) 100%)",
                    }}
                    className="flex flex-col text-white"
                  >
                    <div className="flex justify-end px-5 pt-4 2xl:py-5">
                      <h3 className="flex items-center text-[35px] lg:text-[22px] xl:text-[36px] 2xl:text-[60px]">
                        {expiredUsersValue}
                      </h3>
                    </div>
                    <div className=" text-[22px] lg:pt-[20px] xl:pt-[4px] lg:text-[18px] xl:text-[26px]  2xl:text-[48px] 2xl:pb-4 px-5 lg:pr-0 pb-2 pt-0  2xl:pt-[40px]">
                      <p>Expired Users</p>
                    </div>
                    <hr className="p-1"></hr>
                    <div className="flex lg:pb-4 xl:pb-6 lg:px-2 xl:px-5 text-[12px] lg:text-[9px] xl:text-[12px]  2xl:text-[20px] 2xl:py-3 2xl:pb-12">
                      <ul className="flex items-center space-4xl lg:space-2xl xl:space-4xl">
                        <li>
                          <MdOutlineWatchLater className="text-lg lg:text-xs xl:text-lg 2xl:text-4xl" />
                        </li>
                        <li>
                          <p className="pl-2 pr-5 lg:pr-1 xl:pr-5 2xl:text-2xl">
                            Update :
                          </p>
                        </li>
                        <li className="2xl:text-2xl">
                          <p>
                            {hittime?.split('T')[0]} Time {hittime?.split('T')[1]?.split('.')[0]}
                          </p>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>

                <div
                  className="w-[45%] lg:w-[45%] xl:w-[45%] 2xl:w-[46%] rounded-md overflow-hidden transition-all duration-200"
                  style={{
                    boxShadow: " 0px 4px 4px 0px rgba(0, 0, 0, 0.25)",
                    // border: "1px solid rgba(254, 88, 128, 0.85)",
                  }}
                >
                  <div
                    style={{
                      background:
                        "radial-gradient(153.7% 1063.14% at 108.27% 49.55%, rgba(254, 128, 88, 0.85) 0%, rgba(0, 87, 255, 0.85) 100%)",

                    }}
                    className="flex flex-col text-white"
                  >
                    <div className="flex justify-end px-5 pt-4 2xl:py-5">
                      <h3 className="flex items-center text-[35px] lg:text-[22px] xl:text-[36px] 2xl:text-[60px]">
                        {totalCount}
                      </h3>
                    </div>
                    <div className=" text-[22px] lg:pt-[20px] xl:pt-[4px] lg:text-[18px] xl:text-[26px]  2xl:text-[48px] 2xl:pb-4 px-5 lg:pr-0 pb-2 pt-0  2xl:pt-[40px]">
                      <p> Users</p>
                    </div>
                    <hr className="p-1"></hr>
                    <div className="flex lg:pb-4 xl:pb-6 lg:px-2 xl:px-5 text-[12px] lg:text-[9px] xl:text-[12px]  2xl:text-[20px] 2xl:py-3  2xl:pb-12">
                      <ul className="flex items-center space-4xl lg:space-2xl xl:space-4xl">
                        <li>
                          <MdOutlineWatchLater className="text-lg lg:text-xs xl:text-lg 2xl:text-4xl" />
                        </li>
                        <li>
                          <p className="pl-2 pr-5 lg:pr-1 xl:pr-5 2xl:text-2xl">
                            Update :
                          </p>
                        </li>
                        <li className="2xl:text-2xl">
                          <p>
                            {hittime?.split('T')[0]} Time {hittime?.split('T')[1]?.split('.')[0]}
                          </p>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>

              {/* for table */}
              <div className="w-[43%] flex justify-center lg:py-[15px] xl:py-5 py-5 2xl:py-7">
                <div
                  className=" w-[100%] lg:w-[100%] xl:w-[100%] 2xl:w-[100%]   flex flex-col justify-between  items-center rounded-lg border-1 border-solid border-white border-opacity-60 bg-white bg-opacity-57 shadow-md backdrop-filter backdrop-blur-[5.7px]"
                  style={{
                    boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.20)",
                    background:
                      "radial-gradient(circle at right top, rgba(255, 255, 255, 0.6) 0% , rgba(255, 255, 255, 0.57))",
                  }}
                >
                  <div className="flex flex-col w-full overflow-y-auto dashboardtable1">
                    <div>
                      <p className="pl-4 pt-1 pb-2 font-semibold lg:text-[15px] xl:text-[20px] 2xl:text-[45px] 2xl:pb-4 2xl:pl-8 2xl:pt-4 2xl:text-4xl 2xl:font-semibold">
                        New Users
                      </p>{" "}
                    </div>

                    <table
                      ref={tableRef}
                      className="border border-collapse border-black table-auto"
                      id="myTable"
                    >
                      <thead className="">
                        <tr>
                          <th
                            className="px-4 py-2 text-center text-black border-2 "
                            style={{ borderColor: "rgba(221, 221, 221, 1)" }}
                          >
                            Name
                          </th>
                          <th
                            className="px-4 py-2 text-center text-black border-2 "
                            style={{ borderColor: "rgba(221, 221, 221, 1)" }}
                          >
                            Phone
                          </th>

                          <th
                            className="px-4 py-2 text-center text-black border-2 "
                            style={{ borderColor: "rgba(221, 221, 221, 1)" }}
                          >
                            Created On
                          </th>

                          <th
                            className="px-4 py-2 text-center text-black border-2 "
                            style={{ borderColor: "rgba(221, 221, 221, 1)" }}
                          >
                            Coupon
                          </th>
                        </tr>
                      </thead>
                      <tbody className="">
                        {user.slice()
                          .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
                          .slice(0, 10)
                          .map((user, index) => (
                            <tr key={index}>
                              <td
                                className="px-4 py-2 text-black border-2 "

                                style={{ borderColor: "rgba(221, 221, 221, 1)" }}
                              >
                                <li className="pr-[5px]"> {user.name}</li>
                              </td>
                              <td
                                className="px-4 py-2 text-center text-black border-2 "

                                style={{ borderColor: "rgba(221, 221, 221, 1)" }}
                              >
                                {user.phone}
                              </td>
                              <td
                                className="px-4 py-2 text-center text-black border-2 "

                                style={{ borderColor: "rgba(221, 221, 221, 1)" }}
                              >
                                {user?.createdAt?.split('T')[0]}
                              </td>
                              <td
                                className="px-4 py-2 text-center text-black border-2 "

                                style={{ borderColor: "rgba(221, 221, 221, 1)" }}
                              >
                                {user.cuponapplied}
                              </td>
                            </tr>
                          ))}
                      </tbody>
                    </table>

                    {/* table date and time */}
                    <div className="flex flex-row pt-4 item-center 2xl:pt-6">
                      <MdWatchLater className="pl-2 text-2xl font-semibold lg:text-xl xl:text-3xl xl:pt-1 xl:pb-2 2xl:text-4xl 2xl:pb- 2xl:pl-4 2xl:text-5xl" />
                      <p className="pl-1 text-sm font-semibold lg:text-[12px] xl:text-[15px] 2xl:text-[30px] 2xl:pl-4 2xl:pt-1 2xl:text-2xl">
                        Update :
                      </p>
                      <p className="pl-1 text-sm font-semibold lg:text-[12px] xl:text-[15px] 2xl:text-[30px] 2xl:pt-1 2xl:text-2xl">
                        &ensp; {createdAt?.split('T')[0]} Time {createdAt?.split('T')[1]?.split('.')[0]}
                      </p>{" "}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    </UserSidebar>
  );
}